import React, { useEffect, useState } from "react";
import faker from "faker";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import styles from "./HomePage.module.scss";

import TableComponent from "../components/TableComponent";
import TablePaymentStatus from "../components/TablePaymentStatus";
import LoadingSpinner from "../components/LoadingSpinner";

// const LineChart = React.lazy(() => import("../components/LineChart"));

faker.seed(1);
const columns = [
  {
    title: "Amount",
    dataIndex: "amount",
    render: (text: number) => <div style={{ fontWeight: "bold" }}>{text}</div>,
    key: "amount",
    align: "end",
  },
  {
    title: "",
    dataIndex: "curreny",
    key: "curreny",
  },
  {
    title: "",
    dataIndex: "status",
    key: "status",
    render: (text: number, _: any, key: number) => {
      if (key % 5 === 0) {
        return <TablePaymentStatus key={key} type="refunded" />;
      } else {
        return <TablePaymentStatus key={key} type="successed" />;
      }
    },
  },
  {
    title: "Customer",
    dataIndex: "costumer",
    key: "costumer",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    // align: "center",
  },
];

const chartData = [
  {
    name: "01/2022",
    sales: 4000,
    clicks: 2400,
    views: 2400,
  },
  {
    name: "02/2022",
    sales: 3000,
    clicks: 1398,
    views: 2210,
  },
  {
    name: "03/2022",
    sales: 2000,
    clicks: 9800,
    views: 2290,
  },
  {
    name: "04/2022",
    sales: 2780,
    clicks: 3908,
    views: 2000,
  },
  {
    name: "06/2022",
    sales: 1890,
    clicks: 4800,
    views: 2181,
  },
  {
    name: "07/2022",
    sales: 2390,
    clicks: 3800,
    views: 2500,
  },
  {
    name: "08/2022",
    sales: 3490,
    clicks: 4300,
    views: 2100,
  },
];

type Props = {};

function HomePage({}: Props) {
  const [paymentData, setPaymentData] = useState<any[]>([]);

  function createData() {
    const data = [];

    for (let i = 0; i < 50; i = i + 1) {
      data.push({
        amount: faker.finance.amount(75, 3900, 2, "$"),
        curreny: "USD",
        status: "success",
        key: i,
        costumer: `${faker.name.firstName()} ${faker.name.lastName()}`,
        description: `Invoice ${faker.finance.amount(100000, 200000, 0)}`,
        date: faker.date.recent().toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
      });
    }

    setPaymentData(data);
  }

  useEffect(() => {
    createData();
    return () => {};
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Estimated Gross Volume</h2>
        <div className={styles.buttonsWrapper}></div>
      </div>

      <div className={styles.graphWrapper}>
        <div className={styles.lineChart}>
          <React.Suspense fallback={<LoadingSpinner />}>
            {/* Remove hand made chart */}
            {/* <LineChart /> */}

            <ResponsiveContainer width="100%" height="100%">
              <AreaChart
                width={500}
                height={400}
                data={chartData}
                margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="sales"
                  stackId="1"
                  stroke="#8884d8"
                  fill="#8884d8"
                />
                <Area
                  type="monotone"
                  dataKey="clicks"
                  stackId="1"
                  stroke="#82ca9d"
                  fill="#82ca9d"
                />
                <Area
                  type="monotone"
                  dataKey="views"
                  stackId="1"
                  stroke="#ffc658"
                  fill="#ffc658"
                />
              </AreaChart>
            </ResponsiveContainer>
          </React.Suspense>
        </div>

        <div className={styles.balanceWrapper}>
          <div className={styles.row}>
            <div className={styles.rowHeader}>USD Balance</div>
            <div className={styles.balance}>$9,726.88</div>
            <div className={styles.estimate}>Estimated future payouts</div>
          </div>

          <div className={styles.row}>
            <div className={styles.rowHeader}>Payouts</div>
            <div className={styles.balance}>$1,881.23</div>
            <div className={styles.estimate}>&nbsp;</div>
          </div>
        </div>
      </div>

      <div className={styles.header}>
        <h2>Recent Transactions</h2>
        <div className={styles.buttonsWrapper}></div>
      </div>

      <TableComponent columns={columns} data={paymentData} />
    </div>
  );
}

export default React.memo(HomePage);
